import { notification } from 'antd';
import { t } from 'i18next';

/**
 * Clipboard API YALNIZCA güvenli bağlamda (https:// veya localhost) tanımlıdır. RIS'e düz HTTP
 * üzerinden (ör. http://10.x.x.x) giren kullanıcıda `navigator.clipboard` undefined olur; doğrudan
 * `navigator.clipboard.writeText(...)` çağrısı TypeError fırlatır. Güvenli bağlamda bile promise
 * reddedilebilir (doküman focus'ta değil, izin verilmemiş, kullanıcı jestinden kopmuş çağrı).
 *
 * Bu yüzden erişim opsiyonel zincirle yapılır, red durumunda eski `execCommand('copy')` yoluna
 * düşülür ve fonksiyon HİÇBİR koşulda fırlatmaz — sadece true/false döner. Çağıran taraf render
 * fazında (setState updater'ı, render gövdesi) olsa bile uygulamayı düşürmez.
 */
export const writeClipboard = async (text) => {
    const value = String(text ?? '');

    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(value);
            return true;
        }
    } catch {
        // güvenli bağlam var ama izin/focus reddi → aşağıdaki eski yola düş
    }

    try {
        const area = document.createElement('textarea');
        area.value = value;
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(area);
        return ok;
    } catch {
        return false;
    }
};

/**
 * writeClipboard + kullanıcıya bildirim. Başarı/başarısızlık bilgisini döner.
 */
export const copyToClipboard = async (text, options = {}) => {
    const ok = await writeClipboard(text);

    const {
        successMessage = t('Copied'),
        description,
        errorMessage = t('Copy failed')
    } = options;

    if (ok) {
        notification.success({
            message: successMessage,
            description,
            placement: 'topRight',
            duration: 2
        });
    } else {
        notification.error({
            message: errorMessage,
            placement: 'topRight',
            duration: 3
        });
    }

    return ok;
};
